import controller from '../../Controller.js';
// import './Styles.css'; // imported from main bundle

function Dropdown(container) {
  var trigger;
  var area;
  function init() {
    trigger = container.querySelector('.dropdown__control');
    area = container.querySelector('.dropdown__area');
    var selectTriggers = container.querySelectorAll('.dropdown__select-trigger');
    var id = '_' + Math.random().toString(36).substr(2, 9);

    container.setAttribute('data-dropdown-expanded', 'false')
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', id);
    area.setAttribute('id', id);

    trigger.addEventListener('click', handleTriggerClick);
    selectTriggers.forEach(trigger => {
      trigger.addEventListener('click', handleSelectClick);
    });
    document.body.addEventListener('collapse-all-dropdowns', () => {
      collapse();
    });
  }
  function handleOutsideClick(e) {
    collapse();
  }
  function handleTriggerClick(e) {
    e.preventDefault();
    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    isExpanded ? collapse() : expand();
  }
  function handleSelectClick(e, trigger) {
    var text = container.querySelector('.dropdown__control__text');
    if(text) {
      text.innerHTML = this.getAttribute('data-select-trigger-text');
    }
    collapse();
  }
  function handleAreaClick(e) {
    e.stopPropagation();
  }
  function handleEscKeyPress(e) {
    if(e.keyCode == 27) {
      collapse();
    }
  }
  function expand() {
    document.body.dispatchEvent(new CustomEvent('collapse-all-dropdowns'));
    trigger.setAttribute('aria-expanded', 'true');
    container.setAttribute('data-dropdown-expanded', 'true');
    container.addEventListener('click', handleAreaClick);
    document.body.addEventListener('click', handleOutsideClick);
    document.addEventListener('keydown', handleEscKeyPress);
  }
  function collapse() {
    trigger.setAttribute('aria-expanded', 'false');
    container.setAttribute('data-dropdown-expanded', 'false');
    container.removeEventListener('click', handleAreaClick);
    document.body.removeEventListener('click', handleOutsideClick);
    document.removeEventListener('keydown', handleEscKeyPress);
  }
  return {
    init: init
  }
}

controller.add('Dropdown', Dropdown);

export default Dropdown;
